import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User, PremiumServiceMeta } from '../../../_models';
import { AuthenticationService, NotificationService, PremiumService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './premium-service-meta-list.component.html' })
export class PremiumServiceMetaListComponent implements OnInit {
  newMeta: FormGroup;
  metas: PremiumServiceMeta[];
  currentUser: User;
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;

  filterable = {
    name: '',
  };

  constructor(private fb: FormBuilder,
    private authSvc: AuthenticationService,
    private premiumSvc: PremiumService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  openModal(targetModal, meta: PremiumServiceMeta = null) {
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
    let id = null, name = null, description = null;
    if(meta != null){
      id = meta.id;
      name = meta.name;
      description = meta.description;
    }
    this.newMeta = this.fb.group({
      id: [id],
      name: [name, Validators.required],
      description: [description],
    });
  }

  get f() { return this.newMeta.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(){
    this.filterable = {
      name: '',
    }
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newMeta.getRawValue();
    if (this.newMeta.valid) {
      let id = newDataParam['id'];
      if(id == null || id == ''){
        if (confirm("Are you sure to add the meta now?")) {
          this.premiumSvc.addMeta(newDataParam).subscribe(data => {
            if (data !== null) {
              if (data.status == 1) {
                this.notification.showSuccess("Meta added successfully!", "New Meta");
                this.modalService.dismissAll();
                this.loadPage(1);
              } else {
                this.notification.showError(data.msg, "Fail to add");
              }
            } else {
              this.notification.showError("Failed to add meta, please try again later.", "Fail to add");
            }
          })
        }
      }else{
        if (confirm("Are you sure to update the meta now?")) {
          this.premiumSvc.updateMeta(newDataParam).subscribe(data => {
            if (data !== null) {
              if (data.status == 1) {
                this.notification.showSuccess("Meta updated successfully!", "Update Meta");
                this.modalService.dismissAll();
                this.loadPage(1);
              } else {
                this.notification.showError(data.msg, "Fail to update");
              }
            } else {
              this.notification.showError("Failed to update meta, please try again later.", "Fail to update");
            }
          })
        }
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add/Update failed");
      this.processing = false;
    }
  }

  deleteMeta(account) {
    if (confirm("Are you sure to delete this meta?")) {
      this.premiumSvc.deleteMeta(account.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Meta deleted successfully!", "Delete Meta");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting meta, please try again later.", "Error");
        }
      })
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.metas = [];
    let params = this.formParam(page);

    // get page of items from api
    this.premiumSvc.listMetas(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.metas = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no meta for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      name: this.filterable.name,
    }
    return params;
  }

}
